export default "<span class=\"current-time\">{{formattedDate}}</span>\n"